import { GwMap } from "./map"
class ParksMap extends GwMap {
  constructor(element) {
    super(element)

    this.filteredParks = []
    this.filters = []
    this.ready = false

    this.initFilters()
    this.bindFormEvents()

    this.map.once("load", () => {
      this.ready = true
      this.filterResults()
    })
  }

  initFilters() {
    this.filters = document.querySelectorAll(".park-search__filter")
    this.activityFilter = document.querySelector("[name=activity]")
    this.list = document.querySelector(".parks-search__list")
    this.listItems = document.querySelectorAll(".parks-search__list-item")
    this.seeAll = document.querySelector(".parks-search__see-all")
    this.noResults = document.querySelector(".parks-search__list__no-results")
    this.limitedResultsCount = window.resultsLimit
    this.extraItem = document.querySelector(".parks-search__list-item--extra")

    if (!this.extraItem) {
      this.seeAll.classList.add("d-none")
    }

    // See all button
    this.seeAll.addEventListener("click", e => {
      e.currentTarget.classList.add("d-none")
      this.list.classList.remove("limited-results")
      if (e.pointerType !== "mouse") {
        this.focusFirstItem()
      }
    })
  }

  bindFormEvents() {
    this.filters.forEach(filter => {
      filter.addEventListener("change", () => this.filterResults())
    })
  }

  filterResults() {
    // Dropdowns can fire change events before the map is ready.
    // We cancel these, and trigger the first filter manually.
    if (!this.ready) {
      return
    }

    const activities = [...this.activityFilter.selectedOptions].map(o => o.value)

    this.updateActivitiesParameter(activities)

    this.filteredParks = this.mapData.items.filter(
      park => !activities.length || activities.filter(activity => park.activities.includes(activity)).length
    )

    this.list.classList.add("limited-results")
    this.seeAll.classList.toggle("d-none", this.filteredParks.length <= this.limitedResultsCount)
    this.noResults.classList.toggle("d-none", !!this.filteredParks.length)

    // Filter items
    this.activeCollectionsIDs = this.filteredParks.map(park => park.id)
    let activeItems = 0
    this.listItems.forEach(el => {
      const isActive = this.activeCollectionsIDs.includes(parseInt(el.dataset.id))
      el.classList.toggle("d-none", !isActive)
      el.classList.toggle("parks-search__list-item--extra", isActive && ++activeItems > this.limitedResultsCount)
    })

    this.updateFeaturesVisibility(true)
  }

  updateActivitiesParameter(selectedActivities) {
    // eslint-disable-next-line compat/compat
    const url = new URL(location)
    url.searchParams.set("activities", selectedActivities.join(","))
    history.replaceState({}, "", url)
  }

  // Shifts focus to the first visible item in the list
  focusFirstItem() {
    if (this.extraItem && !this.extraItem.classList.contains("d-none")) {
      const firstLink = this.extraItem.querySelector("a")
      if (firstLink) {
        firstLink.focus()
      }
    }
  }
}

export default function init() {
  if (document.querySelector(".ParksLandingPage")) {
    const mapElement = document.getElementById("map")
    new ParksMap(mapElement)
  }
}
